import { useState, useCallback } from "react";
import { mediaUrl } from "@/lib/api";
import { Reveal, SectionHead } from "./Reveal";
import { Lightbox } from "./Lightbox";

const SPANS = [
  "col-span-2 row-span-2",
  "col-span-1 row-span-1",
  "col-span-1 row-span-2",
  "col-span-1 row-span-1",
  "col-span-2 row-span-1",
  "col-span-1 row-span-1",
  "col-span-1 row-span-1",
];

export const Gallery = ({ s, items }) => {
  const [index, setIndex] = useState(null);
  const close = useCallback(() => setIndex(null), []);
  if (!items.length) return null;
  return (
    <section id="galeria" data-testid="gallery-section" className="bg-[#0F0F12] py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <SectionHead label={s.gallery_label} title={s.gallery_title} subtitle={s.gallery_subtitle} testid="gallery-title" />
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[150px] sm:auto-rows-[200px] lg:auto-rows-[260px] gap-2 sm:gap-3 grid-flow-dense">
          {items.map((g, i) => (
            <Reveal key={g.id} delay={(i % 4) * 0.08} className={SPANS[i % SPANS.length]}>
              <button
                onClick={() => setIndex(i)}
                className="group relative h-full w-full overflow-hidden bg-[#141418] focus-visible:outline focus-visible:outline-1 focus-visible:outline-[#C5A059]"
                aria-label={`Ampliar foto${g.caption ? `: ${g.caption}` : ""}`}
                data-testid={`gallery-item-${i}`}
              >
                <img src={mediaUrl(g.url)} alt={g.caption || "Foto do Gran Hotel Sé"} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.05]" />
                <span className="absolute inset-0 bg-[#08080A]/0 group-hover:bg-[#08080A]/35 transition-colors duration-500" />
                {g.caption && (
                  <span className="absolute left-4 bottom-4 right-4 text-left font-display italic text-white text-base sm:text-lg opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                    {g.caption}
                  </span>
                )}
              </button>
            </Reveal>
          ))}
        </div>
      </div>
      <Lightbox images={items} index={index} onClose={close} onIndex={setIndex} />
    </section>
  );
};
